import { render, staticRenderFns } from "@/style-guide/partials/assets/assets.pug?vue&type=template&id=e49d0dc2&scoped=true&lang=pug&external"
import script from "./assets.vue?vue&type=script&lang=ts"
export * from "./assets.vue?vue&type=script&lang=ts"
import style0 from "./assets.vue?vue&type=style&index=0&id=e49d0dc2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e49d0dc2",
  null
  
)

export default component.exports